import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import clsx from "clsx";
import styles from "./style.module.css";
import Header from "../../components/Header";
import { SKELETON_TIMEOUT } from "../../appConstants/AppConstant";
import Loader from "../../components/Loader";
import { useTranslation } from "react-i18next";
import { FbPixelEvent_PageView } from "../../utils/FbPixel/fbPixel";
import { getPartnerId } from "../../utils/helpers/common";
import { FACEBOOK } from "../../utils/helpers/constants";

export const ExternalLinks: React.FC = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { url = "" } = location.state || {};
  const [loading, setLoading] = useState<boolean>(true);
  const hasTrackedRef = useRef(false);
  
  useEffect(() => {
    if (getPartnerId() === FACEBOOK && !hasTrackedRef.current) {
      hasTrackedRef.current = true;
      FbPixelEvent_PageView();
    }
  }, []);

  useEffect(() => {
    setTimeout(() => setLoading(false), SKELETON_TIMEOUT);
  }, []);

  return (
    <>
      {loading && <Loader transparent />}
      <div className={clsx(styles.externalLinksWrapper)}>
        <Header pageTitle={t('back')} navigate={() => navigate(-1)}/>
        <iframe
          src={url}
          id="external-iframe"
          title="External Content"
          width="100%"
          height="100vh"
          frameBorder="0"
        />
      </div>
    </>
  );
};
